import { render, staticRenderFns } from "./TheBtn.vue?vue&type=template&id=5cd08af4"
import script from "./TheBtn.vue?vue&type=script&lang=js"
export * from "./TheBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports